import { MegafairBrandNormal } from "./megafair-brand-normal.component";
import { MegafairBrandSmall } from "./megafair-brand-small.component";

export type MegafairBrandProps = {
  size?: "normal" | "small";
};

export function MegafairBrand({ size = "normal" }: MegafairBrandProps) {
  if (size === "small") {
    return <MegafairBrandSmall />;
  }

  return <MegafairBrandNormal />;
}
